import { render } from "./GridItem.vue?vue&type=template&id=4bc3029e&scoped=true"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"

import "./GridItem.vue?vue&type=style&index=0&id=4bc3029e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc3029e"]])

export default __exports__